import { render } from "./TreasureDialog.vue?vue&type=template&id=602d06ad&scoped=true"
import script from "./TreasureDialog.vue?vue&type=script&lang=js"
export * from "./TreasureDialog.vue?vue&type=script&lang=js"

import "./TreasureDialog.vue?vue&type=style&index=0&id=602d06ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602d06ad"]])

export default __exports__